module.exports = {
    EXPRESS_CONTEXT_PATH: undefined,
    JEGERWEB_API_URL: undefined,
    OIDC_ACR_VALUES: undefined,
    OIDC_CLIENT_ID: undefined,
    OIDC_REDIRECT_URI: undefined,
    OIDC_POST_LOGOUT_REDIRECT_URI: undefined,
    OIDC_AUTHORITY: undefined,

    SESSION_TIMEOUT_MS: undefined,
    BRREG_FORSIDE_URL: undefined,

    BRREG_JEGERREGISTERET_URL: undefined,
    BRREG_JEGERREGISTERET_FOREIGN_HUNTERS_URL: undefined,
    BRREG_REGISTRER_LISENS_URL_NORSK: undefined,
    BRREG_REGISTRER_LISENS_URL_UTENLANDSK_EN: undefined,
    BRREG_REGISTRER_LISENS_URL_UTENLANDSK_NB: undefined,
    BRREG_SJEKKJEGER_URL: undefined,
    LANDBRUK_URL: undefined,
    ALTINN_URL: undefined,
    LANDINGSSIDE_URL: undefined,
};
